import React, {useState, useEffect, useCallback} from 'react'
import {Card} from '@shopify/polaris'
import {Pagination, Spin} from 'antd'
import {getJobCrawlers} from '../../../services/api/StatisticsServicesAuth'
import JobCrawlersFilter from './JobCrawlersFilter'
import JobCrawlersList from './JobCrawlersList'

const LIMIT = 100

function JobCrawlers() {
    const [source, setSource]   = useState(undefined)
    const [page, setPage]       = useState(1)
    const [data, setData]       = useState([])
    const [total, setTotal]     = useState(0)
    const [loading, setLoading] = useState(false)
    const [error, setError]     = useState(null)

    const fetchData = useCallback(async () => {
        setLoading(true)
        setError(null)
        try {
            const res = await getJobCrawlers({source, page, limit: LIMIT})
            if (res.success) {
                setData(res.data.data)
                setTotal(res.data.total)
            } else {
                setError(res.message || 'Không thể tải dữ liệu. Vui lòng thử lại.')
            }
        } catch (e) {
            setError('Không thể tải dữ liệu. Vui lòng thử lại.')
        } finally {
            setLoading(false)
        }
    }, [source, page])

    useEffect(() => {
        fetchData()
    }, [fetchData])

    const handleSourceChange = (val) => {
        setSource(val)
        setPage(1)
    }

    return (
        <div className="TrackingMapping">
            <Spin spinning={loading} tip="Loading...">
                <Card sectioned>
                    <Card.Subsection>
                        <JobCrawlersFilter source={source} onChange={handleSourceChange}/>
                    </Card.Subsection>
                    <Card.Subsection>
                        {error && <p style={{color: 'red'}}>{error}</p>}
                        <JobCrawlersList data={data} loading={loading}/>
                    </Card.Subsection>
                    <Card.Subsection>
                        <Pagination
                            current={page}
                            pageSize={LIMIT}
                            total={total}
                            onChange={setPage}
                            className="text-right"
                            showSizeChanger={false}
                            showTotal={t => `Tổng ${t} records`}
                        />
                    </Card.Subsection>
                </Card>
            </Spin>
        </div>
    )
}

export default JobCrawlers
